import logo from '@/assets/logo.png';
import { cn } from '@/utils/cn';

/** The anitra BovID logo (sidebar and sign-in); `className` sets its width, the height follows. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <img src={logo} alt="anitra BovID" className={cn('h-auto max-w-full shrink-0', className)} />
  );
}
